// File: App.js
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import QuestionBank from "./components/QuestionBank";
import Board from "./components/BoardMedium/boardMaster";
import BoardDetailsPage from "./components/BoardMedium/BoardDetailsPage";
import AnswerQuestions from "./components/AnswerQuestions";
import ClassManager from "./components/class/pages/viewclass";
import ChapterManager from "./components/chapter/pages/chapter";
import SubjectManager from "./components/subject/pages/viewSubject";
import Login from "./components/login";
import Signup from "./components/Signup";
import DashboardLayout from "./components/Dashboard/DashboardLayout";
import Home from "./components/Dashboard/Home";
import { useAuth } from "./context/AuthContext";
import CollegeQuizQuestion from "./components/LawCollegeQuiz/CollegeQuizQuestion";
import Themes from "./components/SchoolQuiz/Themes";
import Groups from "./components/SchoolQuiz/Group";
import SchoolQuizQuestion from "./components/SchoolQuiz/SchoolQuizQuestion";
import AddManualQuestion from "./components/LawCollegeQuiz/AddManualQuestion";
import AddSchoolQuizManualQuestion from "./components/SchoolQuiz/AddManualQuestion";
import GetQuizQuestions from "./components/LawCollegeQuiz/GetQuizQuestions";
import GetSchoolQuizQuestions from "./components/SchoolQuiz/GetSchoolQuizQuestions";
import CreateQuiz from "./Quiz-Mgt-admin/pages/CreateQuiz";
import CreateSchoolQuiz from "./School-Quiz-Mgt-admin/pages/CreateQuiz";
import QuizStatus from "./Quiz-Mgt-admin/pages/QuizStatus";
import SchoolQuizStatus from "./School-Quiz-Mgt-admin/pages/QuizStatus";
import UserManagement from "./Quiz-Mgt-admin/pages/UserManagement";
import UserManagementSchoolQuiz from "./School-Quiz-Mgt-admin/pages/UserManagement";

import CRUDCategories from "./components/LawCollegeQuiz/CRUDCategories";
import ViewCategory from "./components/categories/ViewCategory";
import SubjectSection from "./components/Sections/ViewSection";
import SchoolSelect from "./School-Quiz-Mgt-admin/schoolmodule/pages/SchoolSelect";
import QuizzesStudent from "./School-Quiz-Mgt-admin/schoolmodule/pages/QuizzesStudent";
import UploadSamplePaper, {
  ViewUploadedSamplePaper,
} from "./components/Sample Paper/ViewOrUploadSamplePaper";
import { Toaster } from "react-hot-toast";
const PrivateRoute = ({ children }) => {
  // const { isAuthenticated } = useAuth();
  // return isAuthenticated ? children : <Navigate to="/login" replace />;
  const { isAuthenticated, loading } = useAuth();
  if (loading) {
    return <div>Loading...</div>;
  }
  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

const App = () => {
  const { isAuthenticated } = useAuth();

  return (
    <>
    <Routes>
      {/* Public Routes */}
      <Route
        path="/login"
        element={
          isAuthenticated ? (
            <Navigate to="/dashboard/home" replace />
          ) : (
            <Login />
          )
        }
      />
      <Route path="/signup" element={<Signup />} />

      {/* Protected Routes */}
      <Route
        path="/"
        element={
          <PrivateRoute>
            <DashboardLayout />
          </PrivateRoute>
        }
      >
        <Route index element={<Navigate to="dashboard/home" />} />
        <Route path="dashboard/home" element={<Home />} />
        <Route path="dashboard/classes" element={<ClassManager />} />
        <Route path="dashboard/categories" element={<ViewCategory />} />
        <Route path="dashboard/chapters" element={<ChapterManager />} />
        <Route path="dashboard/subjects" element={<SubjectManager />} />
        <Route path="dashboard/question-bank" element={<QuestionBank />} />
        <Route path="dashboard/board" element={<Board />} />
         <Route path="/dashboard/boards/:boardId" element={<BoardDetailsPage />} />
        <Route
          path="dashboard/answer-questions"
          element={<AnswerQuestions />}
        />
        <Route
          path="dashboard/college-quiz-questions"
          element={<CollegeQuizQuestion />}
        />
        <Route path="dashboard/themes" element={<Themes />} />
        <Route path="dashboard/group" element={<Groups />} />
        <Route
          path="dashboard/school-quiz-questions"
          element={<SchoolQuizQuestion />}
        />
        <Route
          path="dashboard/add-college-quiz-questions"
          element={<AddManualQuestion />}
        />
        <Route
          path="dashboard/add-school-quiz-questions"
          element={<AddSchoolQuizManualQuestion />}
        />
        <Route path="dashboard/quiz-questions" element={<GetQuizQuestions />} />
        <Route
          path="dashboard/get-school-quiz-questions"
          element={<GetSchoolQuizQuestions />}
        />

        <Route path="dashboard/create-quiz" element={<CreateQuiz />} />
        <Route
          path="dashboard/create-school-quiz"
          element={<CreateSchoolQuiz />}
        />
        <Route
          path="dashboard/view-or-update-quizzes"
          element={<QuizStatus />}
        />
        <Route
          path="dashboard/view-or-update-school-quizzes"
          element={<SchoolQuizStatus />}
        />
        <Route path="dashboard/user-management" element={<UserManagement />} />
        {/* <Route
          path="dashboard/school-user-management"
          element={<UserManagementSchoolQuiz />}
        /> */}
        <Route
          path="dashboard/school-user-management"
          element={<QuizzesStudent />}
        />
        <Route path="dashboard/laws" element={<CRUDCategories />} />
        <Route path="dashboard/section" element={<SubjectSection />} />
        {/* srinu */}
        <Route path="dashboard/school-students" element={<SchoolSelect />} />
        <Route
          path="dashboard/upload-sample-paper"
          element={<UploadSamplePaper />}
        />
        <Route
          path="dashboard/view-uploaded-sample-paper"
          element={<ViewUploadedSamplePaper />}
        />
      </Route>
    </Routes>
    <Toaster position="top-center" reverseOrder={false} />
    </>
  );
};

export default App;
